// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/conversion_events" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdConversionEvents } from "./constants";
import type { UseCaseEnvironment, GetDecisioningStudioAgentsAppGroupIdDsaIdConversionEventsResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdConversionEventsResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdConversionEvents = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdConversionEvents,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string,
    environment?: UseCaseEnvironment
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdConversionEventsResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/conversion_events`,
      "GET",
      { environment },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdConversionEventsResult
);
